/**
 * EditorContext — carries the per-site Yjs document and undo manager
 * so custom xyflow node types (PageNode) can bind y-grid without
 * prop-drilling through xyflow's node renderer boundary.
 */
import { createContext, useContext } from "react";
import type { EditorDoc } from "./useEditorDoc.js";

const EditorContext = createContext<EditorDoc | null>(null);

export const EditorProvider = EditorContext.Provider;

export function useEditorContext(): EditorDoc {
  const ctx = useContext(EditorContext);
  if (!ctx) {
    throw new Error("useEditorContext must be used inside <EditorProvider>");
  }
  return ctx;
}

/** Non-throwing variant for chrome that may render outside a provider (isolated
 *  widget tests, previews) — returns null instead of throwing. */
export function useEditorContextOptional(): EditorDoc | null {
  return useContext(EditorContext);
}
